import { AxInit, ModuleName } from "../../Lib/AxSystem/AxInit";

@ModuleName("AxTopBar")
export class AxTopBar implements AxInit {
    private _InnerMenuOpen: boolean = false;
    private HeroObserver: IntersectionObserver;

    AxInit(slimHeader: boolean): void {
        if (!slimHeader) {
            $(document).ready(x => {
                if ($('.ax-hero').length > 0) {
                    this.CheckTopOffset();

                    this.HeroObserver = new IntersectionObserver(
                        ([e]) => {
                            document.querySelector('.ax-header').classList.toggle('ax-header--transparent', e.intersectionRatio > 0)
                        },
                        { threshold: [0], rootMargin: '-96px 0px 0px 0px' }
                    );

                    if ($('.ax-header').hasClass('ax-header--transparent')) {
                        this.HeroObserver.observe(document.querySelector('.ax-hero'));
                    }
                } else if ($('.ax-header').length > 0) {
                    document.querySelector('.ax-header').classList.toggle('ax-header--transparent', false);
                }
            });

            window.addEventListener("scroll", x => { this.CheckTopOffset() });
        }

        $('a[data-ax-toggler], a[data-topbar-toggler]').each((i, e) => {
            let $target = $("#" + $(e).data('ax-toggler'));
            $target.addClass('ax-toggler');
        });


        $('a[data-ax-toggler="topbar_mobile-menu-language"]').on('click touchstart', function (x) {
            $('#body_overlay').toggleClass('d-none');
        });

        $('a[data-topbar-toggler]').on('click touchstart', e => {
            e.preventDefault();
            let $initiator = $(e.currentTarget);
            let targetID = $initiator.data('topbar-toggler');
            let $target = $("#" + targetID);

            $('a[data-topbar-toggler]').each((i, e) => {
                let difTarget = $(e).data('topbar-toggler');

                if (difTarget != targetID) {
                    $("#" + difTarget).removeClass('ax-slide-y');
                }
            });

            this._InnerMenuOpen = false;

            $target.find('a[data-ax-toggler]').each((i, x) => {
                let $innerToggler = $("#" + $(x).data('ax-toggler'));
                let direction = $(x).data('direction');

                if ($innerToggler.hasClass('ax-slide-x') || $innerToggler.hasClass('ax-slide-y')) {
                    this.ToggleElem($innerToggler, direction);
                    this._InnerMenuOpen = true;
                }
            });
            if (!this._InnerMenuOpen) {
                $('body').toggleClass("position-fixed vw-100 ax-menu-open");

                this.ToggleHeaderMenu($target);

                let $targetBurger = $("#" + $(e.currentTarget).data('burger'));
                $($targetBurger).toggleClass('open');
            }
        });

        $('a[data-ax-toggler]').on('click touchstart', e => {
            e.preventDefault();

            let $target = $("#" + $(e.currentTarget).data('ax-toggler'));
            let direction = $(e.currentTarget).data('direction');

            this.ToggleElem($target, direction);
        });

        $('.ax-nav_sub_mobile-menu').on('click', 'a[data-toggler]', e => {
            let subMenuTarget = $(e.currentTarget).attr('data-toggler');
            $(e.currentTarget).children('i').toggleClass('la-plus').toggleClass('la-minus');
            $('#' + subMenuTarget).slideToggle();
        });
    }

    CheckTopOffset(): void {
        if (document.body.scrollTop > $('.ax-header').height() || document.documentElement.scrollTop > $('.ax-header').height()) {
            $('body').addClass('ax-body--top');
        } else {
            $('body').removeClass('ax-body--top');
        }
    }

    ToggleElem($target, direction) {
        if (direction == 'left') {
            $target.toggleClass('ax-slide-right');
            $target.toggleClass('ax-slide-x');
        }

        if (direction == 'right') {
            $target.toggleClass('ax-slide-left');
            $target.toggleClass('ax-slide-x');
        }

        if (direction == 'top') {
            $target.toggleClass('ax-slide-up');
            $target.toggleClass('ax-slide-y');
        }

        if (direction == 'bottom') {
            $target.toggleClass('ax-slide-down');
            $target.toggleClass('ax-slide-y');
        }
    }

    ToggleHeaderMenu($target: JQuery<HTMLElement>): void {
        $target.toggleClass('ax-slide-up');
        $target.toggleClass('ax-slide-y');
    }
}